import React, { useState } from 'react';
import { Redirect, useHistory, useLocation, useParams } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { MDBBox, MDBContainer, MDBRow } from 'mdbreact';

import BrandItemAdmin from 'components/BrandItemAdmin';
import MembersModalAdmin from 'components/members-modal';
import NoItems from 'components/ui-components/no-items';
import userEmail from 'assets/images/Group 4367.svg' ;
import userIcon from 'assets/images/Group 4369.svg' ;
import { setSelectedBrand } from 'actions/posts';

const UserBrands = props => {
  const { idUser, companyId } = props;
  const dispatch = useDispatch();
  const [modal, setModal] = useState(false);
  const [brandListToEdit, setBrandListToEdit] = useState(null);

  const { pathname } = useLocation();
  const history = useHistory();

  const usersRedux = useSelector(s => s.superAdmin.all_users)?.filter(userItem => userItem.company === companyId);
  const brandsRedux = useSelector(s => s.superAdmin.company_brands)?.filter(compItem => compItem._id === companyId).flatMap(comp => comp.brands);
 
  if (!usersRedux || !brandsRedux) {
    return <Redirect to={`/super-admin`} />;
  }

  let user = usersRedux.find(user => user._id === idUser);
  const brands = brandsRedux.filter(itemProject =>
    itemProject.users?.includes(user._id),
  );

  const projectsToJSX = (
    <MDBRow className="row-cols-lg-4 row-cols-sm-3 row-cols-1 mt-3">
      {brands.map((brand, index) => {
        return (
          <BrandItemAdmin
            projectItem={brand}
            key={brand._id}
            className={index > 3 ? 'mt-4' : ''}
            openTimelines={() => {dispatch(setSelectedBrand(brand)); history.push(`${pathname}/${brand._id}`);}}
            openMemberShipList={() => {
              setBrandListToEdit(brand);
              setModal(true);
            }}
          />
        );
      })}
    </MDBRow>
  );

  return ( 
    <MDBBox className="user-projects">
      <div className="inner-header-position">
        <div className="custom-container d-flex align-items-center justify-content-between py-3">
          <p className="my-heading">Brands</p>
          <div className="d-flex align-items-center">
            <div className='d-flex align-items-center project-admin-header'>
              <img src={userIcon} />
              {user.name} {user.lastName}
            </div>
            <div className='d-flex align-items-center project-admin-header'>
              <img src={userEmail} />
              {user.email}
            </div>
          </div>
        </div>
      </div>

      <MDBContainer size="lg" className="pt-12">
        <MDBBox className="pt-3">
          {brands.length === 0 ? (
            <NoItems text="This user has no brands" />
          ) : null}
          {projectsToJSX}
        </MDBBox>
      </MDBContainer>
      <MembersModalAdmin
        open={modal}
        toggle={() => setModal(s => !s)}
        brandListToEdit={brandListToEdit ? brandListToEdit._id : null}
      />
    </MDBBox>
  );
};

export default UserBrands;
